/* eslint-disable  */
import { LocalizationProvider } from "./locale";
export var Sentry;
(function (Sentry_1) {
    Sentry_1.localizationProvider = new LocalizationProvider({
        locale: "en",
        fallbackLocale: "pl",
        currency: "PLN",
    });
    function captureException(error) {
        const Sentry = window.Sentry;
        if (Sentry) {
            Sentry.captureException(error, {
                tags: {
                    "client.version": "new_restaumatic_client",
                },
            });
        }
    }
    Sentry_1.captureException = captureException;
})(Sentry || (Sentry = {}));
